import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import zh from './zh.json'
import { getStroage } from 'utils'

// 【配置】语言文件
const resources = {
    en: {
        translation: en,
    },
    zh: {
        translation: zh,
    },
}

// 配置框架，使用 react-i18next
i18n.use(initReactI18next).init({
    resources, // 使用语言文件
    lng: getStroage('language') ?? 'en', // 默认使用的语言

    interpolation: {
        escapeValue: false, // 关闭防止 xss 攻击
    },
})

export default i18n
